import * as React from 'react';
import * as cx from 'classnames';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';

import { Theme } from '@material-ui/core/styles/createMuiTheme';

type Kind =
  | 'muted'
  | 'mint'
  | 'mint-underline'
  | 'underline'
  | 'uppercase'
  | 'underline-uppercase'
  | 'mint-uppercase'
  | 'hover-underline';

const styles = (theme: Theme) =>
  createStyles({
    link: {
      fontFamily: theme.typography.fontFamily,
      textDecoration: 'none',
    },
    'kind-muted': {
      color: theme.palette.grey[50],
      fill: theme.palette.grey[50],
      stroke: theme.palette.grey[50],
    },
    'kind-mint-underline': {
      textDecoration: 'underline',
      color: theme.palette.mint.main,
    },
    'kind-mint-uppercase': {
      textTransform: 'uppercase',
      color: theme.palette.mint.main,
    },
    'kind-mint': {
      color: theme.palette.mint.main,
    },
    'kind-underline': {
      textDecoration: 'underline',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    'kind-uppercase': {
      textTransform: 'uppercase',
    },
    'kind-underline-uppercase': {
      textDecoration: 'underline',
      textTransform: 'uppercase',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    'kind-hover-underline': {
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  });

export interface Props
  extends React.AnchorHTMLAttributes<HTMLAnchorElement>,
    WithStyles<typeof styles> {
  to: string;
  children: React.ReactNode;
  className?: string;
  kind?: Kind;
}

const Link: React.SFC<Props> = ({
  to,
  children,
  className,
  classes,
  kind,
  ...rest
}) => (
  <a
    href={to}
    className={cx(className, classes.link, {
      [classes[`kind-${kind}`]]: Boolean(kind),
    })}
    {...rest}
  >
    {children}
  </a>
);

export default withStyles(styles)(Link);
